import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';

export default class IndexRoute extends Route {
  @service store;

  crumb() {
    return {
      name: 'Triggering details',
      path: this.routeName,
    };
  }

  model() {
    return this.store.findRecord('campaign', this.paramsFor('broadcasts.broadcast').campaign_id);
  }

  afterModel(campaign) {
    if (!campaign.isApiTriggered) {
      this.router.transitionTo('campaigns.campaign.overview');
    }

    return super.afterModel(...arguments);
  }

  setupController(controller) {
    super.setupController(...arguments);
    controller.resetEditor();
  }
}
